// import Analytics from "../Pages/Analytics";
// import CompanyAnalytics from "../Components/Analytics/CompanyAnalytics.js";
// import UsersAnalytics from "../Components/Analytics/UsersAnalytics";
// import LeadsAnalytics from "../Components/Analytics/LeadsAnalytics";
// import DemoAnalytics from "../Components/Analytics/DemoAnalytics";
// import UserActivityAnalytics from "../Components/Analytics/UserActivityAnalytics";
// import InvoicesAnalytics from "../Components/Analytics/InvoicesAnalytics";
// import TopSearchedAnalytics from "../Components/Analytics/TopSearchedAnalytics.js";
// import { Navigate } from "react-router-dom"; 

// export const analyticsRoutes = [
//  {
//     path: "/analytics",
//     element: <Navigate to="/analytics/companies" replace />,
//   },
//   {
//     label: "Companies Analytics",
//     path: "/analytics/companies",
//     element: <CompanyAnalytics />,
//   },
//   {
//     label: "Users Analytics",
//     path: "/analytics/users",
//     element: <UsersAnalytics />,
//   },
//   {
//     label: "Leads Analytics",
//     path: "/analytics/leads",
//     element: <LeadsAnalytics />,
//   },
//   {
//     label: "Demo Analytics",
//     path: "/analytics/demo",
//     element: <DemoAnalytics />,
//   },
//   {
//     label: "User Activity Analytics",
//     path: "/analytics/activity",
//     element: <UserActivityAnalytics />,
//   },
//   {
//     label: "Invoices Analytics",
//     path: "/analytics/invoices",
//     element: <InvoicesAnalytics />,
//   },
//   {
//     label: "Top Searched Terms Analytics",
//     path: "/analytics/top-searches",
//     element: <TopSearchedAnalytics />, 
//   },
// ];

// ];

import Analytics from "../Pages/Analytics.js";

export const analyticsRoutes = [
  {
    label: "Analytics",
    path: "/analytics",
    element: <Analytics />,
  },

];